import Button from '@ui-kit/components/Button';
import { ModalActions } from '@ui-kit/components/Modal/Modal';
import { useTranslation } from 'react-i18next';
import { LinkButton } from '@/components/buttons';
import type { ModalProps } from '@/components/ModalRenderer/components/types';
import { Modal } from '@/components/ModalRenderer/Modal';
import { routeMap } from '@/routes/routeMap';

const MigrationToNewTierNeeded = ({ closeModal }: ModalProps) => {
  const { t } = useTranslation(['Modal', 'Common']);

  return (
    <Modal title={t('MigrationToNewTierNeeded.title')}>
      <p>{t('MigrationToNewTierNeeded.info')}</p>
      <ModalActions>
        <LinkButton to={routeMap.credit.tierMigration.root} onClick={closeModal}>
          {t('MigrationToNewTierNeeded.readMore')}
        </LinkButton>
        <Button variant="secondary" onClick={closeModal}>
          {t('Common:cancel')}
        </Button>
      </ModalActions>
    </Modal>
  );
};

export default MigrationToNewTierNeeded;
